/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SharedMobileLinksBlock_viewer = {
    readonly isPopularSearchesEnabled: boolean | null;
    readonly " $refType": "SharedMobileLinksBlock_viewer";
};
export type SharedMobileLinksBlock_viewer$data = SharedMobileLinksBlock_viewer;
export type SharedMobileLinksBlock_viewer$key = {
    readonly " $data"?: SharedMobileLinksBlock_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"SharedMobileLinksBlock_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedMobileLinksBlock_viewer",
  "selections": [
    {
      "alias": "isPopularSearchesEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "popularSearches"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"popularSearches\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '9c02d7e2d7a147a5df33c55512bbd4ee';
export default node;
